
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppPriceListBrowse from "@/components/price-lists/PriceListBrowse.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";

export default Vue.extend({
	methods: {
		close(){
			this.$emit("close");
		},
	},
	components: {
		AppMobileFullScreenContainer,
		AppPriceListBrowse,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.price-lists"
	}
});
